var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFilledCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#D93829"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.997 19.57c.67.67.671 1.756 0 2.427-.67.671-1.756.67-2.426 0l-7.28-7.279-7.279 7.28c-.67.67-1.756.669-2.426 0-.67-.67-.67-1.756 0-2.427l7.28-7.28-7.28-7.279c-.67-.67-.67-1.755 0-2.426.671-.67 1.757-.67 2.426 0l7.28 7.28 7.279-7.28c.67-.67 1.757-.67 2.426 0 .67.67.671 1.756 0 2.426l-7.279 7.28 7.28 7.279z",
    transform: "translate(-765 -1343) translate(765 1343)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilledCross);
export default __webpack_public_path__ + "static/media/icon-filled-cross.43e5454ecdc6a296408d7fe450c775b7.svg";
export { ForwardRef as ReactComponent };